import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";


export class MyreportUnscheduleAction {
    constructor(public myreportId: number) {
    }
}

/**
 * Action Service to void a sale
 */
@Injectable()
export class MyreportUnscheduleService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "myreport-unschedule");
    }
}
